import {useState} from 'react';
import {Button, InputNumber, Row, Col} from 'antd';
import {CategoryType} from "../../api/Constants";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {InventorySelectWidget} from "../fulfillment/InventorySelectWidget";

export const InventorySearchWidget = ({onApiFail, refresh, onSelect, props}) => {
    const [quantity, setQuantity] = useState(0);
    const [item, setItem] = useState(undefined);


    const clearForm = () => {
        setQuantity(0);
        setItem(undefined);
    }

    const select = (item) => {
        setQuantity(0);
        setItem(item);
    }

    const onQuantityChange = (val) => {
        setQuantity(val);
    }

    const onOk = () => {
        if (onSelect) {
            onSelect(item, quantity);
        }
        clearForm();
    }

    const max = item ? fixedToDisplayUnit(item.quantity, item.unit) : 0;

    const okEnabled = item && (quantity > 0)

    const rowStyle = {
        marginTop: "5px",
        marginBottom: "5px"
    }

    const getDisplayQuantity = () => {
        if (item === undefined) return;
        let displayQuantity = fixedToDisplayUnit(item.quantity, item.unit).toString();
        if (item.category === CategoryType.Wholesale) {
            displayQuantity += " g"
        }
        return displayQuantity;
    }

    return <div>
        <Row style={rowStyle}>
            { (item !== undefined) && <Col span={6} style={{color: "#108ee9"}}>
                {item.sku}
            </Col>
            }
            { (item !== undefined) && <Col span={4} style={{color: "#108ee9"}}>
                {getDisplayQuantity()} in inventory
            </Col>
            }
            <Col span={2}>

                <InputNumber placeholder={`quantity`} max={max} value={quantity} onChange={onQuantityChange}/>

            </Col>
            <Col span={4}>
                <Button disabled={!okEnabled} onClick={onOk}>Ok</Button>
            </Col>
        </Row>
        <Row>
            <InventorySelectWidget onApiFail={onApiFail} refresh={refresh} onSelect={select} />
        </Row>
    </div>
}